import { render, staticRenderFns } from "./SetUser.vue?vue&type=template&id=af905680&scoped=true"
import script from "./SetUser.vue?vue&type=script&lang=js"
export * from "./SetUser.vue?vue&type=script&lang=js"
import style0 from "@/styles/index.styl?vue&type=style&index=0&id=af905680&prod&lang=stylus&scoped=true&external"
import style1 from "./SetUser.vue?vue&type=style&index=1&id=af905680&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af905680",
  null
  
)

export default component.exports